<template>
  <div class="update-form-wrapper">
    <form class="update-form" @submit.prevent="onSubmit">

      <div class="row row-2">
        <div class="input-block">
          <label for="email" class="form-label" ref="email">Email</label>
          <input v-model="form.email" name="email" type="text" class="form-control" placeholder="Email">
          <div class="message" v-if="isInputEmpty.email">L'email è richiesta</div>
        </div>

        <div class="input-block">
          <label for="password" class="form-label" ref="password">Modifica password</label>
          <input v-model="form.password" name="password" type="password" class="form-control" id="accountPassword" placeholder="Modifica password">
        </div>

        <div class="input-block">
          <label for="password_confirmation" class="form-label" ref="password_confirmation">Ripeti nuova password</label>
          <input v-model="form.password_confirmation" name="password_confirmation" type="password" class="form-control" id="accountPasswordConfirm" placeholder="Ripeti nuova password">
        </div>
      </div>
      
      <div class="row row-2">
        <div class="input-block">
          <label for="name" class="form-label" ref="name">Nome</label>
          <input v-model="form.name" type="text" name="name" placeholder="Nome">
          <div class="message" v-if="isInputEmpty.name">Il nome è richiesto</div>
        </div>
        <div class="input-block">
          <label for="surname" class="form-label" ref="surname">Cognome</label>
          <input v-model="form.surname" type="text" name="surname" placeholder="Cognome">
          <div class="message" v-if="isInputEmpty.surname">Il cognome è richiesto</div>
        </div>
      </div>

      <div class="row row-1">
        <div class="input-block">
          <label for="phone" class="form-label" ref="phone">Telefono</label>
          <input v-model="form.phone" type="tel" name="phone" placeholder="Telefono">
          <div class="message" v-if="isInputEmpty.phone">Il telefono è richiesto</div>
        </div>
      </div>

      <div class="row row-1">
        <div class="input-block">
          <label for="address" class="form-label" ref="address">Indirizzo</label>
          <input v-model="form.address" type="text" name="address" placeholder="Indirizzo">
          <div class="message" v-if="isInputEmpty.address">L'indirizzo è richiesto</div>
        </div>
      </div>

      <div class="row row-2">
        <div class="input-block">
          <label for="city" class="form-label" ref="city">Città</label>
          <input v-model="form.city" type="text" name="city" placeholder="Città">
          <div class="message" v-if="isInputEmpty.city">La città è richiesta</div>
        </div>
        <div class="input-block">
          <label for="prov" class="form-label" ref="prov">Provincia</label>
          <input v-model="form.prov" type="text" name="prov" placeholder="Provincia" maxlength="2">
          <div class="message" v-if="isInputEmpty.prov">La provincia è richiesta</div>
        </div>
        <div class="input-block">
          <label for="zip" class="form-label" ref="zip">CAP</label>
          <input v-model="form.zip" type="text" name="zip" placeholder="CAP" maxlength="5">
          <div class="message" v-if="isInputEmpty.zip">Il CAP è richiesto</div>
        </div>
      </div>

      <div class="row row-1">
        <div class="input-block">
          <label for="instrument" class="form-label" ref="instrument">Strumento</label>
          <input v-model="form.instrument" type="text" name="instrument" placeholder="Strumento">
          <div class="message" v-if="isInputEmpty.instrument">Lo strumento è richiesto</div>
        </div>
      </div>

      <div class="row row-2">
        <div class="input-block">
          <label for="orchestra" class="form-label" ref="orchestra">Orchestra</label>
          <input v-model="form.orchestra" type="text" name="orchestra" placeholder="Orchestra" ref="orchestra">
          <div class="message" v-if="isInputEmpty.orchestra">L'orchestra è richiesta</div>
        </div>

        <div class="input-block">
          <label for="media_serate_anno" class="form-label" ref="media_serate_anno">Media delle serate in un anno</label>
          <input v-model="form.media_serate_anno" type="number" name="media_serate_anno" placeholder="Media delle serate in un anno" min="0">
          <div class="message" v-if="isInputEmpty.media_serate_anno">La media delle serate in un anno è richiesta</div>
        </div>
      </div>

      <!--<div class="checkboxes">
        <label class="control-checkbox">Sono interessato a ricevere materiale informativo della vostra offerta
        <input type="checkbox" name="contact_consent" ref="contact_consent" />
          <div class="control-indicator"></div>
        </label>

        <label class="control-checkbox">Sono interessato a ricevere la mailing list con le vostre novità
          <input type="checkbox" name="newsletter_consent" ref="newsletter_consent" />
          <div class="control-indicator"></div>
        </label>

        <label class="control-checkbox">Letta l'informativa privacy, acconsento al trattamento dei miei dati personali per le finalità indicate
          <input type="checkbox" name="privacy_consent" ref="privacy_consent" />
          <div class="control-indicator"></div>
        </label>
      </div>-->

      <input type="submit" class="button button-big button-aqua button-anim" value="SALVA">
    </form>

    <snackbar 
      :states="states" 
      :state="state"
      :showSnackbar="showSnackbar"
      @close="showSnackbar = false"
    ></snackbar>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import axios from 'axios/dist/axios';
import Snackbar from './Snackbar.vue';
import scrollTo from './../utils/scroll-to.js';

export default {
  props: ['user', 'isCheckingLogin'],
  
  data() {
    return {
      isPost: false,
      name: undefined,

      states: [
        {
          name: 'success',
          message: 'Le nuove informazioni sono state salvate correttamente.',
          bgColor: 'aqua'
        },
        {
          name: 'failure',
          message: 'C\'è stato un errore nel salvataggio delle informazioni. Per favore, riprova!',
          bgColor: 'light_purple'
        }
      ],
      state: undefined,
      showSnackbar: false,

      form: {
        email: '',
        password: '',
        password_confirmation: '',
        name: '',
        surname: '',
        phone: '',
        address: '',
        city: '',
        prov: '',
        zip: '',
        instrument: '',
        orchestra: '',
        media_serate_anno: ''
      },

      isInputEmpty: {
        email: false,
        password: false,
        password_confirmation: false,
        name: false,
        surname: false,
        phone: false,
        address: false,
        city: false,
        prov: false,
        zip: false,
        instrument: false,
        orchestra: false,
        media_serate_anno: false
      }
    }
  },

  mounted() {
    if(this.$props.isCheckingLogin) {
      this.$eventBus.$on('login:complete', () => this.getUserInfo());
    } else {
      this.getUserInfo();
    }
  },

  methods: {
    getUserInfo: function() {
      if(!this.isPost) {
        this.isPost = true;
        const token = Cookies.get('caramba-token');
        const headers = { 'Authorization': 'Bearer ' + token };
        const getUserInfoInstance = axios.create({headers});
        getUserInfoInstance.post('/api/v1/user/edit', {})
          .then(resp => {
            const d = resp.data;

            this.form.email = d.email != null ? d.email: '';
            this.form.name = d.name != null ? d.name: '';
            this.form.surname = d.surname != null ? d.surname: '';
            this.form.phone = d.phone != null ? d.phone: '';
            this.form.address = d.address != null ? d.address: '';
            this.form.city = d.city != null ? d.city: '';
            this.form.prov = d.prov != null ? d.prov: '';
            this.form.zip = d.zip != null ? d.zip: '';
            this.form.media_serate_anno = d.media_serate_anno != null ? d.media_serate_anno: '';
            this.form.instrument = d.instrument != null ? d.instrument: '';
            this.form.orchestra = d.orchestra != null ? d.orchestra: '';

            /*if(d.contact_consent) {
              this.$refs.contact_consent.setAttribute('checked', 'checked');
            }

            if(d.newsletter_consent) {
              this.$refs.newsletter_consent.setAttribute('checked', 'checked');
            }

            if(d.privacy_consent) {
              this.$refs.privacy_consent.setAttribute('checked', 'checked');
            }*/
            
            this.isPost = false;
          })
          .catch(err => {
            this.isPost = false;
            this.$eventBus.$emit('user:logout', {goToLogin: true});
          });
      }
    },

    checkInputs() {
      this.isInputEmpty.email = !this.isPresent(this.form.email);
      this.isInputEmpty.name = !this.isPresent(this.form.name);
      this.isInputEmpty.surname = !this.isPresent(this.form.surname);
      this.isInputEmpty.phone = !this.isPresent(this.form.phone);
      this.isInputEmpty.address = !this.isPresent(this.form.address);
      this.isInputEmpty.city = !this.isPresent(this.form.city);
      this.isInputEmpty.prov = !this.isPresent(this.form.prov);
      this.isInputEmpty.zip = !this.isPresent(this.form.zip);
      this.isInputEmpty.media_serate_anno = !this.isPresent(this.form.media_serate_anno);
      this.isInputEmpty.instrument = !this.isPresent(this.form.instrument);
      this.isInputEmpty.orchestra = !this.isPresent(this.form.orchestra);

      return !Object.values(this.isInputEmpty).some(this.isTrue);
    },

    isTrue(el) {
      return el === true;
    },

    onSubmit: function(e) {
      const isValid = this.checkInputs();

      if(isValid) {
        const token = Cookies.get('caramba-token');
        const headers = { 'Authorization': 'Bearer ' + token };
        const getUserInfoInstance = axios.create({headers});

        /*
        let data = {};

        data.email = this.$refs.email.value;
        data.name = this.$refs.name.value;
        data.surname = this.$refs.surname.value;
        data.phone = this.$refs.phone.value;
        data.address = this.$refs.address.value;
        data.city = this.$refs.city.value;
        data.prov = this.$refs.prov.value;
        data.zip = this.$refs.zip.value;
        
        if(this.$refs.password.value != '' && this.$refs.password_confirmation.value != '') {
          data.password = this.$refs.password.value;
          data.password_confirmation = this.$refs.password_confirmation.value;
        }

        if(this.$props.user.is_pro) {
          data.media_serate_anno = this.$refs.media_serate_anno.value;
          data.instrument = this.$refs.instrument.value;
          data.orchestra = this.$refs.orchestra.value;
        }
        */

        const data = JSON.parse(JSON.stringify(this.form));
        data.contact_consent = true; //this.$refs.contact_consent.checked;
        data.newsletter_consent = true; //this.$refs.newsletter_consent.checked;
        data.privacy_consent = true; //this.$refs.privacy_consent.checked;

        getUserInfoInstance.post('/api/v1/user/edit', data)
        .then(resp => {
          this.name = resp.data.name;
          this.displaySnackBar('success');
        })
        .catch(err => {
          this.displaySnackBar('failure');
        });
      } else {
        // find the first available error
        const emptyFields = Object.keys(this.form).filter(key => this.isInputEmpty[key]);
        const targetY = this.$refs[emptyFields[0]].offsetTop - 200;
        scrollTo(targetY, 700, 'easeInOutQuint');        
      }
    },

    displaySnackBar: function(state) {
      this.state = state;
      this.showSnackbar = true;
    },

    isPresent(data) {
      return data && data != '';
    }
  },

  components: {
    'snackbar': Snackbar
  }
}
</script>

<style lang="scss" scoped>
@import './../css/variables.css';


.message {
  background: var(--aqua);
  padding: 2px 5px;
  font-size: 14px;
  display: inline-block;
  line-height: 14px;
  position: absolute;
}

.input-block {
  width: 100%;
}

input[type="submit"] {
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/vue/components/UserUpdateForm.vue